import React, { useEffect, useState } from "react";
import { Button, Spinner } from "@/components/ui";
import { endpoints, apiError, pollJob } from "@/lib/api";
import { confirmCost } from "@/lib/confirmCost";
import { Users } from "lucide-react";

export function BulkDmButton({ snapshotId, compact = false }) {
  const [st, setSt] = useState(null);
  const [prog, setProg] = useState(null);
  const [msg, setMsg] = useState("");
  const load = () => endpoints.bulkDmStatus(snapshotId).then((r) => setSt(r.data)).catch(() => {});
  useEffect(() => { load(); }, [snapshotId]); // eslint-disable-line react-hooks/exhaustive-deps

  const run = async () => {
    const n = st?.missing || 0;
    const ok = await confirmCost({
      op: "decision_makers", units: n,
      title: `Find decision makers for ${n} target${n === 1 ? "" : "s"}?`,
      items: [`${n} target${n === 1 ? "" : "s"} without decision makers`, `${st.with_decision_makers} already covered — skipped`],
      llm_calls: n, web_calls: n * 2, estimated_seconds: 40,
    });
    if (!ok) return;
    setMsg("");
    try {
      const r = await endpoints.bulkDmRun(snapshotId);
      if (!r.data.job_id) { setMsg(r.data.message); return; }
      setProg({ done: 0, total: r.data.total });
      const job = await pollJob(`/jobs/${r.data.job_id}`, (j) => setProg({ done: j.progress || 0, total: j.total || r.data.total }), 3000);
      setMsg(job.status === "ready" ? `Done — ${job.result.with_contacts}/${job.result.total} targets now have contacts` : `Error: ${job.error}`);
    } catch (e) { setMsg("Error: " + apiError(e)); } finally { setProg(null); load(); }
  };

  if (!st) return null;
  return (
    <span className="inline-flex items-center gap-2 flex-wrap" data-testid={`bulk-dm-${snapshotId.slice(0, 8)}`}>
      <Button size="sm" variant="outline" onClick={run} disabled={!!prog || !st.missing} data-testid={`bulk-dm-btn-${snapshotId.slice(0, 8)}`}>
        {prog ? <Spinner size={11} /> : <Users size={11} />}
        {prog ? `Hunting ${prog.done}/${prog.total}…` : st.missing ? `Find decision makers (${st.missing})` : compact ? "DMs ✓" : "All targets have decision makers"}
      </Button>
      {msg && <span className="text-[11px] text-gold" data-testid={`bulk-dm-msg-${snapshotId.slice(0, 8)}`}>{msg}</span>}
    </span>
  );
}
